import React from "react";
import PhotoVerification from "../../../components/QcDashboard/views/PhotoVerification";
import QcDriverDocumentDetailsEdit from "../../../components/QcDetails/QcDriverDocumentDetailsEdit";

export const getTabsConfig = () => {
  return [
    {
      path: "1",
      title: "Photo verification",
      component: PhotoVerification,
    },
    {
      path: "2",
      title: "Document verification",
      component: QcDriverDocumentDetailsEdit,
    },
  ];
};
